import { useCallback } from 'react'

import { Box, Text } from '@chakra-ui/react'
import { useSelector } from 'react-redux'

import NoSearchResults from './NoSearchResults'
import SearchOption from './SearchOption'
import SearchOptions from './SearchOptions'
import SearchSelect from './SearchSelect'
import SearchSelectedTags from './SearchSelectedTags'
import { convertDistrictToNumeric, hasPermission } from '../../../utils'

const TagSelect = ({
  district,
  tagOptions = [],
  onSelect = () => {},
  onRemove = () => {},
  inputProps = {},
  preventCreate,
  ...props
}) => {
  const user = useSelector(state => state.auth.user)

  const createNewTag = value => {
    let newTag = {
      label: value,
      district,
    }

    onSelect(newTag)
  }

  const handleKeyDown = useCallback(
    (e, { selectedOptions }) => {
      if (e.key === 'Enter' && !preventCreate) {
        let value = e.target.value.toUpperCase()

        let foundOption = tagOptions.find(({ label }) => label === value)
        let foundSelected = selectedOptions.find(({ label }) => label === value)

        if (!foundOption && !foundSelected && value !== '') createNewTag(value)
        if (foundOption && !foundSelected) onSelect(foundOption)
      }
    },
    [tagOptions, createNewTag, onSelect]
  )

  const filterOptions = useCallback(
    (searchTerm, selectedOptions) => {
      const selectedIds = new Set(selectedOptions.map(opt => opt.value.id))
      const lowerSearch = searchTerm?.toLowerCase() ?? ''

      return tagOptions.filter(tag => {
        if (selectedIds.has(tag.id)) return false
        if (!lowerSearch) return true
        return tag.label.toLowerCase().includes(lowerSearch)
      })
    },
    [tagOptions]
  )

  return (
    <SearchSelect>
      <SearchOptions
        {...props}
        onKeyDown={handleKeyDown}
        inputProps={{
          placeholder: 'Select existing tag(s) from dropdown or create new',
          ...inputProps,
        }}
      >
        {({ searchTerm, selectedOptions }) => {
          const options = filterOptions(searchTerm, selectedOptions)

          if (!options || options.length === 0) {
            return (
              <NoSearchResults>
                {preventCreate ? (
                  <>No tag found</>
                ) : (
                  <>
                    No tag found, press Enter to create <b>{searchTerm}</b> as
                    new tag
                  </>
                )}
              </NoSearchResults>
            )
          }

          return options.map((tag, index) => (
            <SearchOption
              key={`tag-option-${index}`}
              option={{ label: tag.label, value: tag }}
              onSelect={onSelect}
            >
              <Box>
                <Text>{tag.label}</Text>
                {hasPermission(user, 'casework.view_all_casework') && (
                  <Text variant='helper'>
                    District {convertDistrictToNumeric(tag.district)}
                  </Text>
                )}
              </Box>
            </SearchOption>
          ))
        }}
      </SearchOptions>
      <SearchSelectedTags onRemove={onRemove} />
    </SearchSelect>
  )
}

export default TagSelect
